import { defaultButtonProps } from "../../common/components/buttons/sxprops";

export const mainCont = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  paddingX: "10px",
};

export const headerCont = {
  pb: "15px",
  width: "100%",
  alignItems: "start",
  justifyItems: "start",
  pt: { mobile: 2, tablet: 2 },
};

export const actions = {
  mt: "24px",
  width: "100%",
  alignItems: "center",
};

export const addProductButton = {
  ...defaultButtonProps,
  overflow: "hidden",
  whiteSpace: "nowrap",
};

export const imageCell = {
  width: "47px",
  height: "47px",
  borderRadius: "50%",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const paginationCont = {
  boxShadow:
    "0px 8px 12px rgba(0, 0, 0, 0.1), 0px 0px 24px rgba(0, 0, 0, 0.08)",
  height: "44px",
  width: "100%",
  marginTop: "10px",
  borderBottomRightRadius: "12px",
  borderBottomLeftRadius: "12px",
  display: "flex",
  flexDirection: "row",
  justifyContent: { mobile: "flex-start", tablet: "center" },
  alignItems: "center",
  position: "relative",
};

export const emptyCont = {
  height: "400px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const FormCont = (isLaptopAndUp: boolean) => ({
  borderRadius: "8px",
  padding: "20px",
  minWidth: isLaptopAndUp ? "600px" : "100%",
  display: "flex",
  flexDirection: "column",
  border: "3px solid var(--Colors-old-app-bg, rgba(242, 245, 251, 1))",
});
